const ProductStore = {
    product: null,
    setProduct(product) {
        this.product = product
    },
    getProduct() {
        return this.product
    }
}

export default ProductStore;